var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './function-list.module.scss';
import { FunctionName } from '@app/Components/FunctionName/FunctionName';
var FunctionList = /** @class */ (function (_super) {
    __extends(FunctionList, _super);
    function FunctionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FunctionList.prototype.render = function () {
        var _a = this.props, functions = _a.functions, rowId = _a.rowId;
        return (React.createElement("div", null, functions.map(function (f, i) { return (React.createElement("div", { key: f.id, className: "".concat(styles.function, " ").concat(f.isResponsibleInputProvider ? styles.bold : '') },
            React.createElement(FunctionName, { name: f.name, code: f.code, id: 'tt-' + rowId + i }))); })));
    };
    return FunctionList;
}(React.PureComponent));
export { FunctionList };
